import { WithdrawManualRequestSummaryDto } from 'app/interfaces/dto';
import { apiRequestCall } from 'app/services/api';
import { ApiResource } from 'app/services/api/enums';
import { CancelToken } from 'axios';
import { WithdrawRequestFields } from '../hooks/use-withdraw-request-form';

const DEFAULT_DESTINATION_CURRENCY = 'USD';

export const requestPayPalWithdrawSummary = (
  data: WithdrawRequestFields,
  cancelToken: CancelToken
) => {
  return apiRequestCall<WithdrawManualRequestSummaryDto>({
    params: {
      method: 'POST',
      resource: ApiResource.Payments,
      urlPrefix: 'users/withdrawals/paypal',
      data: { destinationCurrency: DEFAULT_DESTINATION_CURRENCY, ...data },
      cancelToken,
    },
    rejectOnCancel: true,
  });
};

export const confirmWithdrawRequest = (data: WithdrawRequestFields, cancelToken: CancelToken) => {
  return apiRequestCall({
    params: {
      method: 'POST',
      resource: ApiResource.Payments,
      urlPrefix: 'users/withdrawals/paypal/confirm',
      data: { destinationCurrency: DEFAULT_DESTINATION_CURRENCY, ...data },
      cancelToken,
    },
    rejectOnCancel: true,
  });
};
